import * as Actions from './actions'

type AppMetadata = {
  roles: Record<string, string> & {meta: {
    role: string
  }}
} & Record<string, unknown>

type Profile = {
  sub?: string
  given_name?: string
  family_name?: string
  app_metadata?: AppMetadata
  email?: string
} | null

interface State {
  error: Error | null
  flashMessage: string | null
  profile: Profile
  loading: boolean
  screen: string
  resetPasswordEmail: string | null
  meta?: Record<string, unknown>
  signinEmail?: string
  status?: Record<string, unknown> | null
}

type Action =
  UserAuthenticated
  | UserAuthenticationFailureAction
  | UserProfileUpdate
  | UserProfileAppMetadata
  | SetLoginFromScreen
  | SigninFlowStarted
  | ResetPasswordFlowStarted
  | NewPasswordFlowStarted
  | SetError
  | SetFlashMessage
  | ResetState
  | InitStatus
  | GetStatus
  | UpdateStatus
  | SetLoading
  | UserSignedOut

interface UserAuthenticationFailureAction {
  type: 'auth/USER_AUTHENTICATION_FAILURE'
  error: Error
}
interface UserAuthenticated {
  type: 'auth/USER_AUTHENTICATED'
  profile: Profile
}
interface UserProfileUpdate {
  type: 'auth/USER_PROFILE_UPDATED'
  profile: Profile
}
interface UserProfileAppMetadata {
  type: 'auth/USER_PROFILE_APP_METADATA'
  app_metadata: AppMetadata
}
interface SetLoginFromScreen {
  type: 'auth/SET_LOGIN_FORM_SCREEN'
  screen: string
  meta: Record<string, unknown>
}
interface SigninFlowStarted {
  type: 'auth/SIGNIN_FLOW_STARTED'
  email: string
}
interface ResetPasswordFlowStarted {
  type: 'auth/RESET_PASSWORD_FLOW_STARTED'
  email: string
}
interface NewPasswordFlowStarted {
  type: 'auth/NEW_PASSWORD_FLOW_STARTED'
}
interface SetError {
  type: 'auth/SET_ERROR'
  error: Error
}
interface SetFlashMessage {
  type: 'auth/SET_FLASH_MESSAGE'
  message: string
}
interface ResetState {
  type: 'auth/RESET_STATE'
}
interface InitStatus {
  type: 'INIT_STATUS'
}
interface GetStatus {
  type: 'GET_STATUS'
  data: Array<Record<string, unknown>>
}
interface UpdateStatus {
  type: 'UPDATE_STATUS'
  data: Array<Record<string, unknown>>
}
interface SetLoading {
  type: 'auth/SET_LOADING'
  loading: boolean
}
interface UserSignedOut {
  type: 'auth/USER_SIGNED_OUT'
}

export const initialState: State = {
  error: null,
  flashMessage: null,
  profile: null,
  loading: false,
  screen: 'login',
  resetPasswordEmail: null
}

export default function reducer (state: State = initialState, action: Action): State {
  switch (action.type) {
    case Actions.USER_AUTHENTICATION_FAILURE:
      return {
        ...state,
        profile: null,
        loading: false,
        flashMessage: null,
        error: action.error
      }
    case Actions.USER_AUTHENTICATED:
      return {
        ...state,
        error: null,
        loading: false,
        flashMessage: null,
        profile: action.profile
      }
    case Actions.USER_PROFILE_UPDATED:
      return {
        ...state,
        profile: action.profile
      }
    case Actions.USER_PROFILE_APP_METADATA:
      return {
        ...state,
        profile: {
          ...state.profile,
          app_metadata: action.app_metadata
        }
      }
    case Actions.SET_LOGIN_FORM_SCREEN:
      return {
        ...state,
        error: null,
        loading: false,
        screen: action.screen,
        meta: action.meta
      }
    case Actions.SIGNIN_FLOW_STARTED:
      return {
        ...state,
        error: null,
        loading: true,
        flashMessage: null,
        signinEmail: action.email
      }
    case Actions.RESET_PASSWORD_FLOW_STARTED:
      return {
        ...state,
        error: null,
        flashMessage: null,
        loading: true,
        resetPasswordEmail: action.email
      }
    case Actions.NEW_PASSWORD_FLOW_STARTED:
      return {
        ...state,
        error: null,
        flashMessage: null,
        screen: 'new-password'
      }
    case Actions.SET_ERROR:
      return {
        ...state,
        loading: false,
        flashMessage: null,
        error: action.error
      }
    case Actions.SET_FLASH_MESSAGE:
      return {
        ...state,
        flashMessage: action.message,
        error: null
      }
    case Actions.RESET_STATE:
      return {
        ...initialState
      }
    case Actions.INIT_STATUS:
      return {
        ...state,
        status: null
      }
    case Actions.GET_STATUS:
      return {
        ...state,
        status: { data: action.data }
      }
    case Actions.UPDATE_STATUS:

      return {
        ...state,
        status: {
          data: []
            // @ts-expect-error // now it's okay
            .concat(state.status?.data || [])
            // @ts-expect-error // now it's okay
            .filter(row => row.id !== action.data.id)
            // @ts-expect-error // now it's okay
            .concat([ action.data ])
        }
      }
    case Actions.SET_LOADING:
      return {
        ...state,
        loading: action.loading
      }
    case Actions.USER_SIGNED_OUT:
    default:
      return state
  }
}
